import React, {ReactElement, useState} from 'react';
import {DeviceType} from '../../../../incase-domain/common/DeviceType.enum';
import {IQuestionElementProps} from '../../../../incase-domain/elements/base/questionElementBase';
import {IElementPhotoAnswerQuestion} from '../../../../incase-domain/elements/question/photoAnswerQuestion';
import QuestionLayout from '../common/QuestionLayout';
import PhotoQuestionAnswer from './PhotoQuestionAnswer';
import {getAnswerType} from '../common/utils';

function PhotoAnswerQuestionElement(props: IQuestionElementProps<IElementPhotoAnswerQuestion>): ReactElement {
    const {element, device = DeviceType.DESKTOP} = props;
    const {answers, answersInARow} = element;
    const [openCommentIndex, setOpenCommentIndex] = useState<number | null>(null);

    return (
        <QuestionLayout element={element} device={device} showConfirmButton={element.haveTryButton}>
            <div className={`c-photoAnswerQuestion c-photoAnswerQuestion--col-${device === DeviceType.MOBILE ? '2' : answersInARow}`}>
                {answers.map((answer, index) => (
                    <PhotoQuestionAnswer
                        key={`photo-question-answer-${element.id}-${index}`}
                        answer={answer.text}
                        imageFit={element.imageFit}
                        answerType={getAnswerType(answer)}
                        imgSrc={answer.imgSrc || ''}
                        comment={answer.comment}
                        debatableColor={element.debatableColor}
                        correctColor={element.correctColor}
                        incorrectColor={element.incorrectColor}
                        onClick={() => {
                            if (answer.comment) {
                                setOpenCommentIndex(openCommentIndex === index ? null : index);
                            } else {
                                setOpenCommentIndex(null);
                            }
                        }}
                        showComment={openCommentIndex === index}
                        setShowComment={(show) => {
                            if (answer.comment) {
                                setOpenCommentIndex(show ? index : null);
                            }
                        }}
                    />
                ))}
            </div>
        </QuestionLayout>
    );
}

export default PhotoAnswerQuestionElement;
